import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Privacy Policy"
        description="Privacy policy for CNESS certification platform - how we collect, use, and protect your data."
        url="/privacy"
      />
      
      <Header />
      
      <main className="pt-24">
        <section className="py-16 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-lg text-gray-600 mb-8">
                  Last updated: {new Date().toLocaleDateString()}
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Information We Collect</h2>
                <p className="text-gray-700 mb-6">
                  We collect information you provide when registering for certification, including organization details, contact information, and assessment data.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. How We Use Your Information</h2>
                <p className="text-gray-700 mb-6">
                  We use your information to provide certification services, communicate with you about your application, and maintain our directory of certified organizations.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Information Sharing</h2>
                <p className="text-gray-700 mb-6">
                  We do not sell personal information. Certified organizations may appear in our public directory with organization name, tier, and basic details only.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Data Security</h2>
                <p className="text-gray-700 mb-6">
                  We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Data Retention</h2>
                <p className="text-gray-700 mb-6">
                  We retain your information for as long as your account is active or as needed to provide services, comply with legal obligations, and resolve disputes.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Your Rights</h2>
                <p className="text-gray-700 mb-6">
                  You have the right to access, update, or delete your personal information. Contact us to exercise these rights.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Contact Us</h2>
                <p className="text-gray-700 mb-6">
                  For privacy-related questions, contact us at <a href="mailto:contact@cness.co" className="text-amber-600 hover:underline">contact@cness.co</a>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPage;